import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntCheckpoint } from "../../../../../models/handBooks/checkpoint";
import {
  useAddCheckpointMutation,
  useDeleteCheckpointMutation,
  useEditCheckpointMutation
} from "../../../../../redux/api/handBooksApi/organic/checkpointApi";

const useCheckpoint = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addCheckpoint] = useAddCheckpointMutation();
  const [deleteCheckpoint] = useDeleteCheckpointMutation();
  const [editCheckpoint] = useEditCheckpointMutation();

  async function onAddCheckpoint(newCheckpoint: EntCheckpoint): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addCheckpoint(newCheckpoint).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteCheckpoint(checkpoint: EntCheckpoint) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteCheckpoint(checkpoint.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditCheckpoint(editedCheckpoint: EntCheckpoint): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editCheckpoint(editedCheckpoint).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddCheckpoint, onDeleteCheckpoint, onEditCheckpoint }

}
export { useCheckpoint };

